import { render, staticRenderFns } from "./farming-banner.vue?vue&type=template&id=55a1bf36&scoped=true&"
import script from "./farming-banner.vue?vue&type=script&lang=ts&"
export * from "./farming-banner.vue?vue&type=script&lang=ts&"
import style0 from "./farming-banner.vue?vue&type=style&index=0&id=55a1bf36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a1bf36",
  null
  
)

export default component.exports